import data from './users.json'
export const namespaced = true

export const state = {
  users: data
}

export const getters = {
  users (state) {
    return state.users
  },
  user (state) {
    return (login) => {
      return state.users.find((u) => {
        return u.login === login
      })
    }
  }
}
